import { Link, useNavigate } from 'react-router-dom';
import SEO from '../../components/shared/SEO';

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505] text-gray-400 font-sans p-6 md:p-20 relative overflow-hidden">
      <SEO title="Privacy Policy" description="How I collect, use, and protect your data." />
      
      <div className="max-w-4xl mx-auto">
        <button onClick={() => navigate(-1)} className="text-[10px] font-black uppercase tracking-[0.3em] text-orange-500 mb-8 block transition-opacity hover:opacity-80">← Back</button>
        <h1 className="text-4xl md:text-7xl font-black text-white mb-4 tracking-tighter uppercase leading-none">Privacy <span className="text-orange-500">Policy</span></h1>
        <p className="text-[10px] font-mono text-gray-600 uppercase tracking-[0.2em] mb-8">Last Updated: February 20, 2026</p>

        <p className="text-lg text-gray-300 font-medium leading-relaxed mb-16 max-w-2xl">
          Your privacy is important to me. This policy explains what data I collect and how it is used.
        </p>
        
        <div className="grid gap-12">
          
          <LedgerSection step="01" title="Data Collection">
            <p className="text-gray-500 font-medium leading-relaxed">
                I collect your email address and basic account information when you sign up.
            </p>
          </LedgerSection>

          <LedgerSection step="02" title="Payment Data">
            <p className="text-gray-500 font-medium leading-relaxed mb-6">
                I do not store your credit card or bank details. All payments are securely handled by <span className="text-white">Lemon Squeezy</span>.
            </p>
            <div className="p-6 bg-emerald-500/5 border border-emerald-500/10 rounded-[2rem]">
                <p className="text-emerald-500 text-[10px] font-black uppercase tracking-widest mb-2">Notice</p>
                <p className="text-sm text-gray-400 font-medium leading-relaxed italic">
                    Lemon Squeezy maintains their own strict privacy policy and is fully PCI-compliant to ensure your sensitive payment information remains protected.
                </p>
            </div>
          </LedgerSection>

          <LedgerSection step="03" title="Usage Data">
            <p className="text-gray-500 font-medium leading-relaxed">
                I may collect anonymous data on how the app is used (e.g., pages visited) to improve the service and create a better experience.
            </p>
          </LedgerSection>

          <LedgerSection step="04" title="Third Parties">
            <p className="text-gray-500 font-medium leading-relaxed">
                I do not sell, trade, or otherwise transfer your personally identifiable information to outside parties, except for the explicit purpose of providing the service (such as processing payments via Lemon Squeezy).
            </p>
          </LedgerSection>

          {/* <LedgerSection step="05" title="Cookies">
            <p className="text-gray-500 font-medium leading-relaxed">
                My website uses cookies strictly to keep you logged in and to remember your preferences across sessions.
            </p>
          </LedgerSection> */}

          <LedgerSection step="05" title="Your Rights & Contact">
            <p className="text-gray-500 font-medium leading-relaxed mb-6">
                You can request to have your data deleted at any time by contacting me directly.
            </p>
            <a href="mailto:envdock@gmail.com" className="inline-block px-6 py-3 rounded-xl border border-orange-500/20 bg-orange-500/5 text-orange-500 font-medium hover:bg-orange-500/10 transition-colors">
                envdock@gmail.com
            </a>
          </LedgerSection>

        </div>
      </div>
    </div>
  );
}

const LedgerSection = ({ step, title, children }) => (
    <section className="relative pl-12 md:pl-20 py-4 border-l border-white/5">
        <span className="absolute left-0 top-6 text-[10px] font-black text-orange-500/40 font-mono tracking-widest">{step}</span>
        <h2 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight mb-6">{title}</h2>
        {children}
    </section>
);